module.exports = __webpack_public_path__ + "img/message-btn.2c6126a1.png";